import { useState, useRef } from "react";
import { Globe, RefreshCw, ExternalLink } from "lucide-react";

const WORLDMONITOR_URL = "http://100.74.66.35:8090";

export function OsintMonitor() {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const handleReload = () => {
    setIsLoading(true);
    setHasError(false);
    if (iframeRef.current) {
      iframeRef.current.src = WORLDMONITOR_URL;
    }
  };

  return (
    <div className="flex flex-col h-[calc(100vh-3.5rem)]">
      {/* Header */}
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-accent/15 flex items-center justify-center">
            <Globe className="w-5 h-5 text-accent" />
          </div>
          <div>
            <h1 className="text-lg font-semibold text-gray-100">
              OSINT Monitor
            </h1>
            <p className="text-xs text-gray-500">
              WorldMonitor — Inteligencia Global en Tiempo Real
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          {/* Status */}
          {isLoading && !hasError && (
            <span className="text-xs text-gray-500 animate-pulse">
              Cargando...
            </span>
          )}
          {!isLoading && !hasError && (
            <span className="flex items-center gap-1.5 text-xs text-emerald-400">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-[pulse-dot_2s_ease-in-out_infinite]" />
              En vivo
            </span>
          )}
          {hasError && (
            <span className="text-xs text-red-400">Desconectado</span>
          )}

          {/* Reload */}
          <button
            onClick={handleReload}
            className="btn-ghost p-2 rounded-lg"
            title="Recargar"
          >
            <RefreshCw className="w-4 h-4" />
          </button>

          {/* Open in new tab */}
          <a
            href={WORLDMONITOR_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-ghost p-2 rounded-lg"
            title="Abrir en nueva pestaña"
          >
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>

      {/* Iframe container */}
      <div className="flex-1 rounded-xl border border-border overflow-hidden bg-surface-1 relative">
        {/* Error overlay */}
        {hasError && (
          <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-3 bg-surface-1">
            <Globe className="w-8 h-8 text-gray-600" />
            <p className="text-sm text-gray-400">
              No se pudo conectar a WorldMonitor
            </p>
            <p className="text-xs text-gray-600">
              Verifica que el servicio esté corriendo en puerto 8090
            </p>
            <button
              onClick={handleReload}
              className="mt-2 px-4 py-2 text-xs rounded-lg border border-border text-gray-400 hover:text-gray-200 hover:bg-surface-3 transition-colors"
            >
              Reintentar
            </button>
          </div>
        )}

        <iframe
          ref={iframeRef}
          src={WORLDMONITOR_URL}
          className="w-full h-full border-0"
          title="WorldMonitor — OSINT Dashboard"
          onLoad={() => {
            setIsLoading(false);
            setHasError(false);
          }}
          onError={() => {
            setIsLoading(false);
            setHasError(true);
          }}
          allow="geolocation; fullscreen"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
        />
      </div>
    </div>
  );
}

export default OsintMonitor;
